<template>
    <v-card flat outlined tile>
        <section-header title="Suggestions" :small="true" class="pl-4 pr-0 py-2"></section-header>
        <infinite-scroller-vertical @scrolledTillBottom="scrolledTillBottom" style="height: 20vh;min-height: 100px" :windowTarget="false">
            <template>
                <v-list dense>
                    <user-list-item v-for="user in suggestedUsers" :key="'suggested-user-' + user.id" :userDetail="user"></user-list-item>
                    <v-skeleton-loader v-if="suggestedUsersLoading" style="width: 100%" type="list-item-avatar@2"></v-skeleton-loader>
                </v-list>
            </template>
        </infinite-scroller-vertical>
    </v-card>
</template>
<script>
import userListItem from "@/components/list-item/list-item-user.vue"
import suggestedUsersMixin from "@/mixins/mixin-suggested-users"

export default {
    mixins: [suggestedUsersMixin],
    components: {
        userListItem
    }
}
</script>